import { render, staticRenderFns } from "./popContact.vue?vue&type=template&id=f4c10874&scoped=true"
import script from "./popContact.vue?vue&type=script&lang=js"
export * from "./popContact.vue?vue&type=script&lang=js"
import style0 from "./popContact.vue?vue&type=style&index=0&id=f4c10874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c10874",
  null
  
)

export default component.exports